"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const CoreContext_1 = require("../_InternalComponents/CoreContext");
const isDomainDifferent_1 = require("../_InternalUtils/isDomainDifferent");
const getStyles = () => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
});
/**
 * A component that can be used as an autocomplete-option
 *
 * @example ### Basic example
 *
 * This example shows a basic rendering of this component as options inside an Autocomplete component.
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicAutocompleteOptionGroup.jsx
 * ```
 *
 *
 * @param props Props has a group as the only required prop
 * @returns A custom option to be used with the Autocomplete component
 */
const AutocompleteOptionGroup = (props) => {
    const { group, ...rest } = props;
    const styles = getStyles();
    const contextDomain = react_1.default.useContext(CoreContext_1.CoreContext)?.domain;
    return (react_1.default.createElement(ListItem_1.default, { ...rest },
        react_1.default.createElement(Box_1.default
        // Makes it possible to override the className and thereby the styling of the div element
        , { 
            // Makes it possible to override the className and thereby the styling of the div element
            sx: {
                ...styles.wrapper,
                ...(group.flags.includes("deleted") && { textDecoration: "line-through" }),
            } },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, group.name),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary" },
                (0, isDomainDifferent_1.isDomainDifferent)(contextDomain, group?.domain) && `${group.domain.name}/`,
                group.shortName,
                group.customer && ` - ${group.customer.name}`))));
};
exports.default = AutocompleteOptionGroup;
